import DatePicker from "react-datepicker";

class CustomDatePicker extends DatePicker {
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
      if(!nextProps.selected) {
          this.setState({ inputValue: null });
      }
  }

  deferFocusInput = () => {
    this.cancelFocusInput();
  }
}

export default CustomDatePicker;
